class ParfumCollectionSlider {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('.parfum-col-feature__slider');
    this.slides = container.querySelectorAll('.parfum-col-feature__slide');
    this.counterCurrent = container.querySelector('.parfum-col-feature__counter-current');
    this.prevBtn = container.querySelector('.parfum-col-feature__nav-btn--prev');
    this.nextBtn = container.querySelector('.parfum-col-feature__nav-btn--next');
    
    if (!this.slider || !this.slides.length) return;
    
    this.init();
  }
  
  init() {
    // Nav Click handlers
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollSlider('prev'));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollSlider('next'));
    
    // Scroll event to update progress (debounced)
    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateProgress(), 50);
    }, { passive: true });

    // Initial state
    this.updateProgress();
  }
  
  scrollSlider(direction) {
    const slideWidth = this.slides[0].offsetWidth;
    const scrollAmount = direction === 'next' ? slideWidth : -slideWidth;
    this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
  
  scrollToSlide(index) {
    const slideWidth = this.slides[0].offsetWidth;
    this.slider.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
  }
  
  updateProgress() {
    if (!this.slides.length || !this.counterCurrent) return;
    const slideWidth = this.slides[0].offsetWidth;
    const index = Math.round(this.slider.scrollLeft / slideWidth);
    
    this.counterCurrent.textContent = index + 1;
  }
}

function initParfumSliders() {
  document.querySelectorAll('.parfum-col-feature').forEach(container => {
    if (!container.dataset.sliderInitialized) {
      new ParfumCollectionSlider(container);
      container.dataset.sliderInitialized = 'true';
    }
  });
}

// Global initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initParfumSliders);
} else {
  initParfumSliders();
}

// Shopify Theme Editor re-initialization
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('section-parfum-collection-feature') || event.target.querySelector('.parfum-col-feature')) {
    initParfumSliders();
  }
});
